export async function requestDebugFileLines(
  paths: readonly string[],
): Promise<Record<string, number>> {
  const query = new URLSearchParams({ files: paths.join(",") });
  const response = await fetch(`/api/debug/file-lines?${query}`, {
    credentials: "same-origin",
    signal: AbortSignal.timeout(5000),
  });
  if (!response.ok) return {};
  return (await response.json()) as Record<string, number>;
}
